import { SET_CUSTOM_FIELD_5 } from 'actions';

export function setCustomField5(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_5 };
}
